export default __webpack_public_path__ + "static/media/Akash_singh_cloud_lead.ef4ce9c5.jpg";